<template>
  <ul class="py-4">
    <li v-for="(movie, index) in movies" :key="index">
      <router-link
        :to="{
          path: '/movies/',
          name: 'MovieDetails',
          params: {
            id: movie.id
          }
        }"
        class="border-gray-600 border-b mb-4 pb-2 overflow-hidden flex item-center hover:opacity-50"
      >
        <div class="w-16 h-16 border border-gray-800 rounded mr-8">
          <img
            :src="profileImageUrl(movie['poster_path'])"
            :alt="'loading...'"
            class="rounded w-full h-full"
          />
        </div>
        <div class="flex flex-col">
          <span class="text-sm mb-2">
            {{ movie["title"] }}
            ({{ getYear(movie["release_date"] || movie["first_air_date"]) }})
          </span>
          <span class="text-yellow-500 block mb-2"
            ><i class="fas fa-star mr-2"></i> {{ movie["vote_average"] }}</span
          >
        </div>
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  props: ["movies"]
};
</script>
